<template>
    <div class="product">
        <div class="pro01">
            <div class="proTxt">
                <h2 class="text-center">农网末端低电压治理装置</h2>
                <p>针对山区农村地区出现用户电压过低，偏远地区农户用电受到影响的问题。中恒善能提出采用电力电子技术对现有偏远农村地区供电进行改造的方案，通过对农村偏远地区的电网拓扑进行调查，针对拓扑结构的复杂性和通用性的分析，定义了专用于农村微电网治理类别的产品。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-1">
                <el-row>
                    <el-col :span="12">
                        <div class="kuai">
                            <h1 style="margin: 40px 0;">农网末端低电压治理装置是基于电池系统的双向微电网控制设备，充分利用微电网的控制策略原理，控制目标由微电网的系统稳定改为配合电网的供电能力保证节点（含负荷端和配网关键节点）的电压稳定设备。</h1>

                            <span style="font-size:20px;">主要针对农网基础薄弱、供电半径大、负荷不稳定的现状，适合农村、山区等供电半径大的地区。</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="kuai">
                            <img src="../../assets/img/product/pro6.jpg"  style="width: 350px; margin-left:100px;" />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="content-2">
            <div class="block-bottom-head">
                <span class="black-block"></span>
                <span class="ch">详细参数</span>
                <span class="en">Parameters</span>
            </div>
            <el-row>
                <el-col :span="12">
                    <div>
                        <img src="../../assets/img/product/pro6-1.png" style="height: 300px; padding-left: 25%; float: left;width:320px;" />
                    </div>
                </el-col>
                <el-col :span="12">
                    <div>
                        <h3 style="margin: 10px 0;">1.治理方式创新</h3>
                        <span style="padding: 10px;">分散治理 灵活布置 多级治理</span>
                        <h3 style="margin: 10px 0;">1.补偿方式创新</h3>
                        <span style="padding: 10px;">无功有功同时补偿 降低线损 不影响非治理用户</span>
                        <h3 style="margin: 10px 0;">3.装置结构创新</h3>
                        <span style="padding: 10px;">设备功能高度集成 降低运维成本</span>
                        <h3 style="margin: 10px 0;">4.控制策略创新</h3>
                        <span style="padding: 10px;">多种控制策略 稳定用户侧同时提高电池寿命</span>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
    
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.product {
    width: 100%;
    height: 100%;
}

.center-block {
    display: block;
    margin-right: auto;
    margin-left: auto;
}

.img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
}

.pro01 {
    margin-top: 50px;
    position: relative;
    width: 100%;
    height: 350px;
    background: url(../../assets/img/banner6.jpg) no-repeat top center;

    .proTxt {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        width: 100%;

        h2 {
            max-width: 900px;
            color: #fff;
            margin: 80px auto 30px;
            font-size: 36px;
            font-weight: 500;
        }

        .text-center {
            text-align: center;
        }

        p {
            max-width: 900px;
            margin: 5px auto;
            text-indent: 2em;
            line-height: 30px;
        }
    }
}

.content {
    height: 450px;
    width: 80%;
    margin: 0 auto;
    margin-top: 70px;

    .kuai {
        height: 250px;
        width: 90%;
        margin: 0 auto;
    }
}
.content-2 {
    background-color: #F8F8F8;
    height: 600px;
    padding-top: 30px;

    .block-bottom-head {
        margin-left: 12%;
        margin-top: 60px;
        margin-bottom: 50px;

        span { display:inline-block; }

        .black-block {
            width: 20px;
            height: 20px;
            border-radius: 2px;
            background: #000;
        }

        .ch {
            font-size: 40px;
            line-height: 56px;
            margin-left: 20px;
            margin-right: 20px;
        }

        .en {
            font-size: 30px;
            line-height: 37px;
        }

    }
}

</style>